import { neueVorgangsId } from './bonierung';

/**
 * Codex K-7 (Entscheidung E-LAGER 1): eine Vorgangskennung je Lagervorgang. Ein erneuter
 * Versuch mit GLEICHEM Inhalt – z. B. nach einem Netzfehler, dessen Antwort verloren ging –
 * sendet dieselbe Kennung, der Server bucht dann nicht doppelt. Geänderter Inhalt oder ein
 * bestätigter Erfolg (`erledigt`) ergibt beim nächsten Mal eine neue Kennung.
 */
export class VorgangsKennung {
  private inhalt: string | null = null;
  private kennung = '';

  constructor(private readonly erzeuge: () => string = neueVorgangsId) {}

  fuer(inhalt: unknown): string {
    const schluessel = JSON.stringify(inhalt);
    if (schluessel !== this.inhalt) {
      this.inhalt = schluessel;
      this.kennung = this.erzeuge();
    }
    return this.kennung;
  }

  /** Nach bestätigtem Erfolg: der nächste Vorgang bekommt eine neue Kennung. */
  erledigt(): void {
    this.inhalt = null;
  }
}
